import script from "./AnnualLeaveRule.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnualLeaveRule.vue?vue&type=script&setup=true&lang=js"

import "./AnnualLeaveRule.vue?vue&type=style&index=0&id=714c6bf7&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-714c6bf7"]])

export default __exports__